import { types as layoutTypes } from './layout';
import { actions as lineActions } from './salesorderLines';
import { types as soTypes } from './salesOrders';
import { difference, findIndex } from 'lodash';
import svc from 'svc';



export const types = {
	SET_STATE: 'ITEMS/SET_STATE',
	RESET_ALL: 'ITEMS/RESET_ALL',
	DELETE_ROW: 'ITEMS/DELETE_ROW',
};

/* LINE SAMPLE
	Item: '1095AF-02', //*
	Key: 0,
	Qty: 1, //*
	UnitPrice: 133.7, //*
	Price: 13.37, //*
	PriceAfterVat: 133.7, //*
	TaxCode: 'EX', //*
	//...Optional...
	Description: 'Its cool',
	DiscountByPercent: 5
 */

export const initialState = {
	queryingItem: false,
	searching: false,
	searched: [],
	selected: [],
	selectedCodes: [],
	queried: {},
};


export default ( state = initialState, action ) => {
	switch (action.type) {
		case types.SET_STATE:
			return { ...state, ...action.data };
		case types.RESET_ALL:
			return { ...initialState };
		case types.DELETE_ROW:
			let removalIndex = action.lineID + 1 + state.selected[ action.lineID ].childCount;
			let selCodeIndex = state.selectedCodes.indexOf( state.selected[ action.lineID ].Item );
			return {
				...state,
				selected: [
					...state.selected.slice( 0, action.lineID ),
					...state.selected.slice( removalIndex ),
				],
				selectedCodes: [
					...state.selectedCodes.slice( 0, selCodeIndex ),
					...state.selectedCodes.slice( selCodeIndex + 1 ),
				],
			};
		default:
			return state;
	}
}

export const actions = {
	setState: ( data ) => ({ type: types.SET_STATE, data }),
	resetAll: () => ({ type: types.RESET_ALL }),
	deleteRow: ( lineID ) => ({ type: types.DELETE_ROW, lineID }),

	addItem: ( itemCode, priceList ) => {
		return ( dispatch, getState ) => {
			let state = getState();
			let queried = state.items.queried;
			let initialUpdate = { queryingItem: true };
			let selectedCodes = [ ...state.items.selectedCodes ];
			let cardCode = state.businessPartners.bp.Code;
			let isOrder = !state.salesOrders.isQuote;
			let warehouses = state.salesOrders.warehouses;
			let parentItems = state.items.selected.filter( item => {
				return (item.hasOwnProperty( 'removable' ) && item.removable);
			} ).map( item => {
				return item.Item;
			} );

			if ( parentItems.indexOf( itemCode ) !== -1 ) {
				let index = findIndex( state.items.selected, { Item: itemCode, removable: true } );

				let newRows = [
					...state.items.selected.slice( 0, index ),
					{ ...state.items.selected[ index ], Qty: Number( state.items.selected[ index ].Qty ) + 1 },
					...state.items.selected.slice( index + 1 ),
				];

				dispatch( actions.setState( { selected: newRows } ) );
				return true;
			}

			if ( queried.hasOwnProperty( itemCode ) ) {
				let { children: queriedChildren, ...parent } = queried[ itemCode ];

				if ( selectedCodes.indexOf( parent.Item ) === -1 ) {
					selectedCodes.push( parent.Item );
				}

				let children = queriedChildren.map( child => {
					if ( selectedCodes.indexOf( child.Item ) === -1 ) {
						selectedCodes.push( child.Item );
					}
					return { ...child, Qty: 1 };
				} );

				initialUpdate.selected = [ ...state.items.selected, {
					...parent,
					Qty: 1,
					removable: true,
				}, ...children ];
				if ( state.items.selectedCodes.length !== selectedCodes.length ) {
					initialUpdate.selectedCodes = selectedCodes;
				}

				initialUpdate.queryingItem = false;
				dispatch( actions.setState( initialUpdate ) );
				return true;
			}
			dispatch( actions.setState( initialUpdate ) );

			svc.send( 'item', { method: 'getItem', itemCode, priceList, cardCode } ).then( res => {
				let update = [ ...state.items.selected ];
				let parent = res.payload.item;
				let children = res.payload.children;
				let selectedCodes = [ ...state.items.selectedCodes ];
				parent.removable = true;
				parent.childCount = children.length;
				parent.Qty = 1;
				if ( state.appData.DefaultWhs && isOrder && parent.WhsCode === '100' ) parent.WhsCode = state.appData.DefaultWhs;

				if ( parent.lockedWhs.indexOf( parent.WhsCode ) !== -1 ) {
					let available = difference( warehouses, parent.lockedWhs );
					if ( !available.length ) {
						dispatch( { type: layoutTypes.NOTIFY, text: `Unable add item: no unlocked warehouses.` } );
						return false;
					}

					parent.WhsCode = available[ 0 ];
					dispatch( {
						type: layoutTypes.NOTIFY,
						text: `Default Warehouse locked for ${parent.Item}, automatically set to first available (${parent.WhsCode})`,
					} );
				}

				update.push( parent );

				let queriedUpdate = { ...queried, [ parent.Item ]: { ...parent, children: children } };

				children.forEach( child => {
					//let orig = {...child};
					child = { ...child };
					if ( state.appData.DefaultWhs && isOrder ) child.WhsCode = state.appData.DefaultWhs;
					if ( selectedCodes.indexOf( child.Item ) === -1 ) {
						selectedCodes.push( child.Item );
					}

					child.removable = false;
					child.DiscountByPercent = 100;
					child.childCount = 0;
					child.Qty = 1;
					child.Price = 0;

					update.push( child );
				} );

				if ( selectedCodes.indexOf( parent.Item ) === -1 ) {
					selectedCodes.push( parent.Item );
				}

				dispatch( actions.setState( {
					queryingItem: false,
					selected: update,
					queried: queriedUpdate,
					selectedCodes,
				} ) );
			} ).catch( err => {
				dispatch( actions.setState( { queryingItem: false } ) );
				dispatch( { type: layoutTypes.NOTIFY, text: 'Error getting item details' } );
			} );
		};
	},


	search: ( term, priceList ) => {
		return ( dispatch ) => {
			dispatch( actions.setState( { searching: true } ) );

			svc.send( 'item', {
				method: 'listItems',
				priceList: priceList,
				searchString: term,
			} ).then( res => {
				dispatch( actions.setState( { searching: false, searched: res.payload.data } ) );
				dispatch( {
					type: layoutTypes.NOTIFY,
					text: `Search completed, ${res.payload.data.length} items found`,
				} );
			} ).catch( err => {
				dispatch( actions.setState( { searching: false, searched: [] } ) );
				dispatch( { type: layoutTypes.NOTIFY, text: 'Error performing search.' } );
			} );
		};
	},


	getRecent: ( quote, cardCode, priceList ) => {
		return ( dispatch ) => {
			dispatch( actions.setState( { searching: true } ) );

			svc.send( 'item', {
				method: 'listRecentItems',
				priceList,
				cardCode,
				quote,
			} ).then( res => {
				dispatch( actions.setState( { searching: false, searched: res.payload.data } ) );
				dispatch( { type: layoutTypes.NOTIFY, text: `Loaded ${res.payload.data.length} recent items` } );
			} ).catch( err => {
				dispatch( actions.setState( { searching: false, searched: [] } ) );
				dispatch( { type: layoutTypes.NOTIFY, text: 'Error getting recent items.' } );
			} );
		};
	},


	inlineSearch: ( itemCode, priceList, rowID ) => {
		return ( dispatch, getState ) => {
			let state = getState();
			let cardCode = state.businessPartners.bp.Code;
			let isOrder = !state.salesOrders.isQuote;
			let warehouses = state.salesOrders.warehouses;

			svc.send( 'item', { method: 'getItem', itemCode, priceList, cardCode } ).then( res => {
				if ( !res.payload.item ) {
					let soUpdate = {
						showItemsDialog: true,
						itemSearch: itemCode,
						activeRow: rowID,
					};
					dispatch( { type: soTypes.SET_STATE, data: soUpdate } );
					return false;
				}

				let update = [];
				let parent = res.payload.item;
				let children = res.payload.children;
				parent.removable = true;
				parent.childCount = children.length;
				parent.Qty = 1;
				if ( state.appData.DefaultWhs && isOrder && parent.WhsCode === '100' ) parent.WhsCode = state.appData.DefaultWhs;

				if ( parent.lockedWhs.indexOf( parent.WhsCode ) !== -1 ) {
					let available = difference( warehouses, parent.lockedWhs );
					if ( !available.length ) {
						dispatch( { type: layoutTypes.NOTIFY, text: `Unable add item: no unlocked warehouses.` } );
						return false;
					}

					parent.WhsCode = available[ 0 ];
					dispatch( {
						type: layoutTypes.NOTIFY,
						text: `Default Warehouse locked for ${parent.Item}, automatically set to first available (${parent.WhsCode})`,
					} );
				}


				update.push( parent );

				children.forEach( child => {
					child = { ...child };
					child.removable = false;
					child.childCount = 0;
					child.Qty = 1;
					child.Price = 0;
					if ( state.appData.DefaultWhs && isOrder ) child.WhsCode = state.appData.DefaultWhs;
					update.push( child );
				} );

				dispatch( lineActions.updateLine( update, rowID ) );
			} ).catch( err => {
				dispatch( actions.setState( { queryingItem: false } ) );
				dispatch( { type: layoutTypes.NOTIFY, text: 'Error getting item details' } );
			} );
		};
	},


};
